export const images: any = {
  // insurance
  motor: require('./img/third_party.jpg'),
  travel: require('./img/travel_insurance.jpg'),
  pa: require('./img/personal_accident.jpg'),
  health: require('./img/hospital_cash.jpg'),
  crop: require('./img/index_crop.jpg'),
  pd: require('./img/category_cpd.png'),
  health_care: require('./img/category_hc.png'),
  sample_car_left_front: require('./img/sample_car_left_front.png'),
  sample_car_left_rear: require('./img/sample_car_left_rear.png'),
  sample_car_right_front: require('./img/sample_car_right_front.png'),
  sample_car_right_rear: require('./img/sample_car_right_rear.png'),

  // logo
  BSH: require('./img/product/icon_bsh.png'),
  GIC: require('./img/product/icon_gic.png'),
  MSIG: require('./img/product/icon_msig.png'),
  UIC: require('./img/product/icon_uic.png'),
  ignite_app_logo: require('./img/ignite_app_logo.jpg'),

  no_data_img: require('./img/no_data_img.png'),
  success_icon: require('./img/success_icon.jpg'),
  onboarding_banner: require('./img/onboarding_banner.jpg'),
  onboarding_banner_h5: require('./img/onboarding_banner_h5.jpg'),

  ignite: require('./img/ignite.png'),
  email_icon: require('./img/email_icon.jpg'),
  no_data_icon: require('./img/no_data_icon.png'),

  commission_icon: require('./img/commission_icon.jpg'),
  gift_icon: require('./img/gift_icon.jpg'),
  team_member: require('./img/team_member.png'),
  team_sale: require('./img/team_sale.png'),
  personal_icon: require('./img/personal_icon.png'),
  tick_icon: require('./img/tick_icon.png'),
  vehicle_icon: require('./img/vehicle_icon.png'),
  motorcycle_icon: require('./img/motor_icon.png'),
  travel_icon: require('./img/travel_icon.png'),
  pa_icon: require('./img/pa_icon.png'),
  hc_icon: require('./img/hc_icon.png'),
  hour_glass: require('./img/hour_glass.png'),
  hourglass_phone: require('./img/hourglass_phone.png'),
  tob_icon: require('./img/tob_icon.png'),

  // svg
  email_verification: require('./svg/email_verification.svg'),
  img_dele_icon: require('./svg/img_dele.svg'),
  img_placeholder: require('./svg/img_placeholder.svg'),
  team_icon: require('./svg/team.svg'),
  total_premium_icon: require('./svg/total_premium.svg'),
  total_premium_orange_icon: require('./svg/total_premium_orange.svg'),
  tooltip_icon: require('./svg/tooltip.svg'),
  job_title_icon: require('./svg/job_title.svg'),
  phone_icon: require('./svg/phone.svg'),
  small_email_icon: require('./svg/email.svg'),
  commission_orange_icon: require('./svg/commission_orange.svg'),
  policy_orange_icon: require('./svg/policy_orange.svg'),
};
